module.exports = {
    getUser: function() {
        const user = sessionStorage.getItem('user');
        if (user === 'undefined' || !user) {
            return null;
        } else {
            return JSON.parse(user); // fixed: was JSON.pasrse (typo)
        }
    },

    getToken: function() {
        const token = sessionStorage.getItem('token');
        return token || null;
    },

    getRole: function() {
        return sessionStorage.getItem('role') || null;
    },

    setUserSession: function(user, token, role) {
        sessionStorage.setItem('user', JSON.stringify(user));
        sessionStorage.setItem('token', token);
        if (role) sessionStorage.setItem('role', role);
    },

    resetUserSession: function() {
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('role');
    }
}